/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Backtohome2Inputs */

const he_common_backtohome2 = /** @type {(inputs: Common_Backtohome2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חזרה לדף הבית`)
};

const en_common_backtohome2 = /** @type {(inputs: Common_Backtohome2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Home`)
};

/**
* | output |
* | --- |
* | "Back to Home" |
*
* @param {Common_Backtohome2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_backtohome2 = /** @type {((inputs?: Common_Backtohome2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Backtohome2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_backtohome2(inputs)
	return en_common_backtohome2(inputs)
});
export { common_backtohome2 as "common_backToHome" }